const EmptyRouterView = () => /* webpackChunkName: "EmptyRouterView" */ import("./../views/service_administrator/EmptyRouterView.vue");
const ServiceAdministrator = () => /* webpackChunkName: "Home" */ import("./../views/service_administrator/Home.vue");
const PatientHome = () => /* webpackChunkName: "PatientHome" */ import("./../views/service_administrator/patient/PatientHome.vue");
const ArchiveRequest = () => /* webpackChunkName: "ArchiveRequestHome" */ import("./../views/service_administrator/archive_request/ArchiveRequestHome.vue");
const Archive = () => /* webpackChunkName: "Archive" */ import("./../views/service_administrator/archive/Archive.vue");
const ControllerMedic = () => /* webpackChunkName: "ControllerMedicHcm" */ import("./../views/service_administrator/telemedical/ControllerMedicHcm.vue");
const InterconsultHome = () => /* webpackChunkName: "InterconsultHome" */ import("./../views/service_administrator/Interconsult/InterconsultHome.vue");
const SomeHcm = () => /* webpackChunkName: "SomeHcm" */ import("./../views/service_administrator/telemedical/SomeHcm.vue");
const FilePatient = () => /* webpackChunkName: "FilePatient" */ import("./../views/service_administrator/telemedical/FilePatient.vue");
const Interconsult = () => /* webpackChunkName: "Interconsult" */ import("./../views/service_administrator/telemedical/Interconsult.vue");
const PatientManager = () => /* webpackChunkName: "PatientHome" */ import("./../views/some_hcm/patient/PatientHome.vue");
const MaintainerSchedule = () => /* webpackChunkName: "MaintainerShedule" */ import("../views/service_administrator/MaintainerShedule.vue");
const MaintainerBlockedDay = () => /* webpackChunkName: "MaintainerBlockedDay" */ import("../views/service_administrator/MaintainerBlockedDay.vue");
const MentalHealthArchive = () =>
  /* webpackChunkName: "MentalHealthArchive" */ import("./../views/service_administrator/mental_health_archive/MentalHealthArchive.vue");
const ProfesionalManteiner = () => /* webpackChunkName: "ProfesionalManteiner" */ import("./../views/service_administrator/ProfesionalManteiner.vue");
const RegisterAtentions = () => /* webpackChunkName: "registerAtentions" */ import("./../views/service_administrator/registerAtention/registerAtentions.vue");
const MedicAtention = () => /* webpackChunkName: "medicAtentions" */ import("./../views/service_administrator/medic_atention/medicAtentions.vue");
const Document = () => /* webpackChunkName: "Document" */ import("@/views/general/Document.vue");

export const routes = [
  {
    path: "/service-administrator",
    component: EmptyRouterView,
    children: [
      {
        path: "",
        name: "serviceAdministratorHome",
        component: ServiceAdministrator,
      },
      {
        path: "gestor-pacientes",
        name: "serviceAdministratorPatientHome",
        component: PatientHome,
      },
      {
        path: "solicitud-archivo",
        name: "serviceAdministratorArchiveRequest",
        component: ArchiveRequest,
      },
      {
        path: "archivo",
        name: "serviceAdministratorArchive",
        component: Archive,
      },
      {
        path: "interconsulta-medico-contralor",
        name: "serviceAdministratorcontrollerMedicHcm",
        component: ControllerMedic,
      },
      {
        path: "interconsulta-home-medico-contralor",
        name: "serviceAdministratorinterconsultMedicContra",
        component: InterconsultHome,
      },
      {
        path: "teleinterconsulta-some-hcm",
        name: "serviceAdministratorsomeHcmTic",
        component: SomeHcm,
      },
      {
        path: "ficha-paciente-some-hcm",
        name: "serviceAdministratorsomeHcmFilePatient",
        component: FilePatient,
      },
      {
        path: "interconsulta-some-hcm",
        name: "serviceAdministratorsomeHcmInterconsult",
        component: Interconsult,
      },
      {
        path: "gestion-paciente",
        name: "serviceAdministratorsomeHcmPatientManager",
        component: PatientManager,
      },
      {
        path: "mantenerdor-agenda",
        name: "serviceAdministratormanteinerScheduleSomeHcm",
        component: MaintainerSchedule,
      },
      {
        path: "mantenerdor-dias-bloqueados",
        name: "serviceAdministratormanteinerBlockedDaySomeHcm",
        component: MaintainerBlockedDay,
      },
      {
        path: "cartola-salud-mental",
        name: "serviceAdministratorarchiveSomeHcm",
        component: MentalHealthArchive,
      },
      {
        path: "mantenedor-profesionales",
        name: "serviceAdministratorprofesionalManteinerSomeHcm",
        component: ProfesionalManteiner,
      },
      {
        path: "registro-antecedentes",
        name: "serviceAdministratormedicHospRegisterAtentions",
        component: RegisterAtentions,
      },
      {
        path: "atencionMedica",
        name: "serviceAdministratormentalHealthMedicAtention",
        component: MedicAtention,
      },
      {
        path: "documentacion",
        name: "serviceAdministratorDocumentation",
        component: Document,
      },
    ],
  },
];
